import { withResetState } from "store/hocs";

import { terminalConstants } from "./terminal.constants";
import { merchantListConstants } from "../../merchantList/merchantList.constants";

const initialState = {
	filters: {},
	isCreateStageOnlyVarInProgress: false,
};

function merchantTerminal(state = initialState, action) {
	switch (action.type) {
		case merchantListConstants.RESET_MERCHANT_INFO_STATE: // Persist filters
			return {
				...initialState,
				filters: {
					...state.filters,
				},
			};

		case terminalConstants.SET_CREATE_STAGE_ONLY_VAR_IN_PROGRESS:
			return {
				...state,
				isCreateStageOnlyVarInProgress: action.inProgress,
			};

		default:
			return state;
	}
}

export default withResetState({ initialState })(merchantTerminal);
